import { ChangeDetectionStrategy, Component, input } from "@angular/core";

import { NavigationModule, SideNavVariant } from "@bitwarden/components";

@Component({
  selector: "app-side-nav",
  templateUrl: "web-side-nav.component.html",
  imports: [NavigationModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebSideNavComponent {
  readonly variant = input<SideNavVariant>("secondary");
}
